import { ObservableArray, View } from "binder"
import { InvoicePaymentViewModel, IPaymentMethod, singlePayment } from "./invoicePayment-viewModel"

export class InvoicePaymentView extends View<InvoicePaymentViewModel>{
    GetViewUniqueId(): string {
        return "V-ABED952C-EBB0-4EDA-8CF8-14DC5DD2ADC4"
    }
    loadHtml(): string {
        let element = require('./invoicePayment.html').default;
        let style = require('./invoicePayment.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set payedAmount(v: number) { this._payedAmount = v; } public get payedAmount(): number { return this._payedAmount;} private _payedAmount: number;
    public set invoiceAmount(v: number) { this._invoiceAmount = v; } public get invoiceAmount(): number { return this._invoiceAmount;} private _invoiceAmount: number;
    public set remainingAmount(v: number) { this._remainingAmount = v; } public get remainingAmount(): number { return this._remainingAmount;} private _remainingAmount: number;
    public set realRemainingAmount(v: number) { this._realRemainingAmount = v; } public get realRemainingAmount(): number { return this._realRemainingAmount;} private _realRemainingAmount: number;
    public set realPaidAmount(v: number) { this._realPaidAmount = v; } public get realPaidAmount(): number { return this._realPaidAmount;} private _realPaidAmount: number;
    public set remainingAmountWithCredit(v: number) { this._remainingAmountWithCredit = v; } public get remainingAmountWithCredit(): number { return this._remainingAmountWithCredit;} private _remainingAmountWithCredit: number;
    public set payments(v: ObservableArray<singlePayment>) { this._payments = v; } public get payments(): ObservableArray<singlePayment> { return this._payments;} private _payments: ObservableArray<singlePayment>;
    public set paymentMethods(v: ObservableArray<IPaymentMethod>) { this._paymentMethods = v; } public get paymentMethods(): ObservableArray<IPaymentMethod> { return this._paymentMethods;} private _paymentMethods: ObservableArray<IPaymentMethod>;
    public set selectedPaymentMethod(v: IPaymentMethod) { this._selectedPaymentMethod = v; } public get selectedPaymentMethod(): IPaymentMethod { return this._selectedPaymentMethod;} private _selectedPaymentMethod: IPaymentMethod;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    
    pay(){
        this.dataContext.pay();
    }
    close(){
        this.dataContext.close();
    }
}
